import axios from '../axios'

// 楼栋配置列表
export const save = (data) => {
    return axios({
        url: '/main/capabilitylayer/server/save',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/AIsave.js